import { getToken } from 'firebase/messaging';
import isEqual from "lodash/isEqual";

import { FirebaseMessageProps } from '../../components/firebase/firebase.types';
import { messaging } from '../../firebase/config';

const RequestFirebaseMessagingToken = async ({ fcmTokens, id, updateUserFcmTokens }: FirebaseMessageProps) => {
  try {
    const permission = await Notification.requestPermission();

    if (permission !== 'granted') {
      console.error('Notification permission denied');
      return;
    }

    if ('serviceWorker' in navigator) {
      const existingRegistrations = await navigator.serviceWorker.getRegistrations();
      let registration = existingRegistrations.find(reg => reg.scope.endsWith('/firebase-messaging-sw.js'));
      if (!registration) {
        registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js')
          .catch((error) => {
            console.error('Service Worker registration failed:', error);
            if (error.message.includes('failed to register')) {
              console.log('Registering a fallback service worker...');
              return navigator.serviceWorker.register('/dummy-sw.js')
                .then((fallbackRegistration) => {
                  console.log('Fallback Service Worker registered with scope:', fallbackRegistration.scope);
                  return fallbackRegistration;
                })
                .catch((fallbackError) => {
                  console.error('Fallback Service Worker registration failed:', fallbackError);
                  throw fallbackError;
                });
            }
            throw error;
          });
      }

      await navigator.serviceWorker.ready;

      const token = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
        serviceWorkerRegistration: registration,
      });

      if (!token) {
        console.error('No registration token available. Request permission to generate one.');
        return;
      }

      if (Array.isArray(fcmTokens)) {
        const updatedTokens = fcmTokens.includes(token) ? fcmTokens : [...fcmTokens, token];

        if (!isEqual(updatedTokens, fcmTokens)) {
          try {
            const { data } = await updateUserFcmTokens({
              variables: {
                id,
                fcm_tokens: updatedTokens,
              },
            });
            console.log('FCM tokens updated successfully:', data);

          } catch (error) {
            if (error instanceof Error) {
              console.error('Error updating FCM tokens:', error.message);
            } else {
              console.error('An unknown error occurred during FCM token update:', error);
            }
          }
        } else {
          console.log('Token already exists in fcmTokens, no update needed.');
        }
      }

    } else {
      console.error('Service Workers are not supported in this browser.');
    }
  } catch (error) {
    if (error instanceof Error) {
      console.error('An error occurred while retrieving token:', error.message);
    } else {
      console.error('An unknown error occurred:', error);
    }
  }
};

export default RequestFirebaseMessagingToken;
